import { computeCaptureSize } from '@lib/media/frameCaptureCore';

export const getThumbnailFromVideo = (
  video: HTMLVideoElement,
  quality: number = 0.8,
  /**
   * Cap on the output width, height following the aspect ratio. Omit for a
   * full-resolution grab.
   *
   * Worth passing whenever the result is only ever displayed small: a 1080p frame
   * costs a few hundred KB as a base64 data URL, and drawing straight to the
   * smaller canvas avoids that intermediate entirely rather than rescaling after.
   */
  maxWidth?: number,
): string | null => {
  // Sizing comes from `computeCaptureSize` rather than being re-derived here — it
  // is the same aspect-fit-and-clamp arithmetic, and it has a test.
  // `maxDimension: 0` opts out of its 1280px ceiling, since omitting `maxWidth`
  // here has always meant a full-resolution grab.
  const { width, height } = computeCaptureSize({
    sourceWidth: video.videoWidth,
    sourceHeight: video.videoHeight,
    maxWidth,
    maxDimension: 0,
  });
  if (!width || !height) return null;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  return canvas.toDataURL('image/jpeg', quality);
};
